// winPanel.js
var WinPanel = pc.createScript('winPanel');

var timeoutBtn;

// initialize code called once per entity
WinPanel.prototype.initialize = function() {

    WinPanel.instance = this;
    var self = this;
    this.entity.on("destroy", this.OnDestroy,this);

    this.entity.children[3].element.text = 'SCORE: ' + PlayerManager.instance.userData.score.toString();

    if (PlayerManager.instance.userData.gameMode != gamePlayMode.MiniGame) {
        if (PlayerManager.instance.levelData.levelName != "Donut Shop") {
            if (ScoreManager.instance.maxComboCounter > 0) {
                this.entity.children[8].enabled = true;
                this.entity.children[8].children[1].element.text = ScoreManager.instance.maxComboCounter + "x";
            }
            else {
                this.entity.children[8].enabled = false;
            }
        }
    }


    winScore = PlayerManager.instance.userData.score;

    this.entity.children[1].button.once('click', function (event) {

        if (PlayerManager.instance.userData.level == 1 && PlayerManager.instance.userData.score == 6) {
            WinPanel.instance.nextLoadScene();
        }
        else {
            rewardedType = adsType.InterstitialFinishWinGame;
            levelEndAd = true;
            
            if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
                gdsdk.showAd()
                    .then(response => {
                    })
                    .catch(error => {
                        console.log("Error Rewarded ADS");
                        WinPanel.instance.nextLoadScene();
                    });
            }
        }

    });

    this.entity.children[5].button.once('click', function (event) {
        clearTimeout(timeoutBtn);
        WinPanel.instance.entity.children[1].enabled = true;
    });

};

WinPanel.prototype.nextLoadScene = function () {
    WinAndLoseUi.instance.showPanelBackground(false);
    if (GameAnalyticsSdk.instance.gaStatus) { GameAnalytics("addDesignEvent", "LevelEndContinueButton:Click", 1); }
    SoundManager.instance.stopSound('WinSound');
    SpawnManager.instance.clearObjects();
    matchObjectCounter = 0;
    CoverManager.instance.updateMatchStatus(0, 0, false);

    if (completeMatchStatus == true) { WinAndLoseUi.instance.perfectBanner.destroy(); }

    if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
        loadScene(`MiniGames`, { hierarchy: true, settings: true });
    }
    else {

        if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal) {
            if (!GameManager.instance.isGameFinish) {
                //if ((PlayerManager.instance.userData.level <= 13) || ((PlayerManager.instance.levelData.levelName == "Gym") && (PlayerManager.instance.levelData.levelName == "Living Room"))) {
                showPlaceModUI = false;

                PlayerManager.instance.userData.score = 0;
                if (levelUpStatus) {
                    slideTop();
                }

                loadScene(`LoadingScene`, { hierarchy: true, settings: true }, () => {

                    if (PlayerManager.instance.userData.newPlayer == true && isTutorialStageComplete == false) {
                        PreloadManager.instance.loadGameAssets("DonutItem", function (complete) {
                            if (complete) {

                                loadScene(`Game`, { hierarchy: true, settings: true }, () => {
                                    GameManager.instance.GameStart();
                                });
                            }
                        });
                    }
                    else {
                        PreloadManager.instance.loadGameAssets(PlayerManager.instance.levelData.levelItem, function (complete) {
                            if (complete) {

                                loadScene(`Game`, { hierarchy: true, settings: true }, () => {

                                    if (PlayerManager.instance.userData.interruption == 1 && (PlayerManager.instance.userData.placeMode === false)) {

                                        this.app.root.findByName("RestorePanel").enabled = true;
                                    }
                                    else {
                                        GameManager.instance.GameStart();
                                    }
                                });
                            }
                        });
                    }

                });

            }
            else {
                PlayerManager.instance.userData.unlockLevel = true;
                PlayerManager.instance.SavePlayerData();
                loadScene(`Menu`, { hierarchy: true, settings: true });
            }

        }
        else if (PlayerManager.instance.userData.gameMode == gamePlayMode.Places) {
            let placesScore = this.entity.children[3].element.text.split(' ')[1];
            this.sendAndUpdateScore(placesScore);

            loadScene(`Menu`, { hierarchy: true, settings: true });
        }
        else {
            showPlaceModUI = false;
            PlayerManager.instance.userData.score = 0;
            if (levelUpStatus) {
                slideTop();
            }

            loadScene(`LoadingScene`, { hierarchy: true, settings: true }, () => {

                if (PlayerManager.instance.userData.newPlayer == true && isTutorialStageComplete == false) {
                    PreloadManager.instance.loadGameAssets("DonutItem", function (complete) {
                        if (complete) {
                            loadScene(`Game`, { hierarchy: true, settings: true }, () => {
                                GameManager.instance.GameStart();
                            });
                        }
                    });
                }
                else {
                    PreloadManager.instance.loadGameAssets(PlayerManager.instance.levelData.levelItem, function (complete) {
                        if (complete) {

                            loadScene(`Game`, { hierarchy: true, settings: true }, () => {

                                if (PlayerManager.instance.userData.interruption == 1 && (PlayerManager.instance.userData.placeMode === false)) {

                                    this.app.root.findByName("RestorePanel").enabled = true;
                                }
                                else {
                                    GameManager.instance.GameStart();
                                }
                            });
                        }
                    });
                }

            });
        }
    }
    completeMatchStatus = false;

    //self.entity.destroy();
};

WinPanel.prototype.sendAndUpdateScore = function (score) {

    var gameAnalyticsCustomFields = {
        "PlayTime": GameManager.instance.gamePlayDuration()
    };
    PlayerManager.instance.userData.userScore = parseInt(PlayerManager.instance.userData.userScore) + parseInt(score);
    PlayerManager.instance.SavePlayerData();   
    //ProgressStatusBar.instance.updateScore();
    if (GameAnalyticsSdk.instance.gaStatus) {
        GameAnalytics("addProgressionEvent", "Complete", "Places", GameManager.instance.placeData.levelName, detectCurrentLevel()[0], parseInt(score), gameAnalyticsCustomFields);
        GameAnalytics("addDesignEvent", "GamePlayTime:Places:" + GameManager.instance.placeData.levelName, parseFloat(GameManager.instance.gamePlayDuration()));
    }
};

WinPanel.prototype.OnDestroy = function(){
    this.entity.off("destroy", this.OnDestroy,this);
};



